import { PAYMENT_BEHAVIOR } from "@/helpers/order/payment/behavior";
import { makePaymentResult } from "../paymentResult";

/**
 * Windcave integration processor.
 *
 * Consumes the response returned by the checkout's `WindcavePaymentProcessing`
 * (which wraps makeWindcavePayment). The raw response is stored verbatim as the
 * processor_response; Windcave does not surface a card last-four in the legacy
 * payment record.
 */
export const windcaveProcessor = {
  behaviors: [PAYMENT_BEHAVIOR.WINDCAVE_INTEGRATION],

  normalize(response) {
    return makePaymentResult({
      approved: !!response,
      processorResponse: response,
      cardLastFour: null,
      raw: response,
    });
  },
};
